/*
 * Module for the workflow group/user dependent dropdowns.
*/

rs.module("controls/workflow/groupuserlist",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var groupSelect = $.js(jsSelectors.groupSelect);
            var userSelect = $.js(jsSelectors.userSelect);
            var userSelectHelper = selectHelper.getHelper(userSelect);

            // When the group changes, reload the dependent dropdown of users
            groupSelect.change(function () {

                var selectedGroup = $(this).val();

                // make the call to update/replace values of the userlist based on the selected group
                userSelectHelper.loadOptionsFrom(backendUrls.getWorkflowUsers, { groupName: selectedGroup }, { withBlank: true });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);